/* eslint-disable import/no-unresolved */
import { useEffect, useState } from 'react';
import { Button, Typography, styled } from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import { useAppDispatch, useAppSelector } from 'src/hooks';
import '../save-scenario-dialog/save-scenario-dialog.scss';
import './load-saved-scenario.scss';
import { getTableColumnData } from 'src/components/collapsible-table/table-column-prep';
import { useNavigate } from 'react-router';
import useModuleMetadata from 'src/hooks/use-module-metadata.hook';
import useMatomoFunction from 'src/hooks/use-matomo-function.hook';
import { getListOfSavedScenarios } from '../../../scenarios/store/scenario-slice';
import { Scenario } from '../../../scenarios/types/scenario.model';
import ScenarioListDialog from '../../../scenario-list-dialog/scenario-list-dialog';
import { TableComponent } from '../../types/generic-table.model';
import { setScenario } from '../../../home/store/simulator-home-slice';
import {
  getAccessConfigForScenario,
  getListOfScenariosForTable
} from '../../../home/store/simulator-home-async-thunks';
import MODULE_TO_PAGE_MAP from '../../../home/types/simulation-module-to-page-map';
import { fetchScenarioDetails } from '../../../home/api/simulator-module-api';
import { MatomoEventTrackMapObject } from '../../../constants/constant';

const StyledButton = styled(Button)`
  background-color: #fcf1e8;
  border-radius: 10px;
  color: #ff6400;
`;

const getScenarioLandingRoute = (scenario: Scenario) => {
  return `/srm/simulator/${scenario.pk_id}/${
    (scenario?.planner_included ?? true) ? 'planner': 'innovation'
  }`;
}

function LoadSavedScenarioDialog() {
  const { source } = useAppSelector((state) => state.user);
  const navigate = useNavigate();

  const [isOpen, setIsOpen] = useState(false);
  /*  Variable to list down all the scenarios to duplicate */
  const [isOpenOnDuplicateClick, setIsOpenOnDuplicateClick] = useState(false);

  const { sourceId } = useModuleMetadata({
    module: MODULE_TO_PAGE_MAP.PLANNER_HOME
  });

  const appDispatch = useAppDispatch();
  useEffect(() => {
    appDispatch(getListOfSavedScenarios({ source_id: source }));
  }, []);

  /* Handler to load the selected scenario for duplication */
  const handleLoadScenarioCloseForDuplicate = () => {
    setIsOpen(false);
    setIsOpenOnDuplicateClick(false);
  };
  const { callFunction } = useMatomoFunction();

  const getPageName = () => {
    const pageTitle = window.location.href.split('/').at(-1);
    return pageTitle;
  };
  const onScenarioLoad = (scenarios: { scenario_id: number }[]) => {
    const [selectedRowDetails] = scenarios;
    if (selectedRowDetails) {
      callFunction(
        MatomoEventTrackMapObject.track_load_saved_scenario_button_click
          .event_key,
        getPageName()
      );
      return fetchScenarioDetails(sourceId, selectedRowDetails?.scenario_id)
        .then((response) => response.data)
        .then((scenario) => {
          appDispatch(setScenario(scenario));
          navigate(getScenarioLandingRoute(scenario));
          return appDispatch(
            getAccessConfigForScenario({
              scenarioId: scenario.pk_id,
              sourceId: source
            })
          );
        });
    }
    return Promise.resolve();
  };

  const handleClickOpenLoadScenario = () => {
    // get list of all the created scenarios
    appDispatch(
      getListOfScenariosForTable({
        sourceId
      })
    );
    setIsOpen(true);
  };

  const { scenarioList, isFetchingScenarios, inputColsForScenario } =
    useAppSelector((state) => state.simulatorHome);

  const [columns, setColumns] = useState([]);

  useEffect(() => {
    setColumns([
      ...getTableColumnData(
        inputColsForScenario,
        TableComponent.SCENARIOMANAGER,
        []
      )
    ]);
  }, [inputColsForScenario]);

  return (
    <>
      <StyledButton
        sx={{ boxShadow: 3 }}
        variant='contained'
        onClick={handleClickOpenLoadScenario}
      >
        <SaveIcon sx={{ fontSize: '2rem', margin: 2 }} />
      </StyledButton>
      <div>
        <Typography variant='text1'>Load Saved Scenario</Typography>
      </div>
      {isOpen ? (
        <ScenarioListDialog
          title='Load Saved Scenario'
          fetchingTableData={isFetchingScenarios}
          open={isOpen}
          // eslint-disable-next-line @typescript-eslint/no-empty-function
          onClose={handleLoadScenarioCloseForDuplicate}
          tableRows={scenarioList.row}
          tableColumns={columns}
          footerBtnName='Load'
          isMultiple={false}
          onScenarioLoad={onScenarioLoad}
        />
      ) : null}
    </>
  );
}

export default LoadSavedScenarioDialog;
